import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import QuestionnaireListContainer from '../../containers/QuestionnaireList';
import i18n from '../../resources/i18n';
/**
 * アンケート一覧画面
 * @param props
 */
const Questionnaire: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Questionnaire_0001')} />
			<QuestionnaireListContainer {...props} />
		</>
	);
};

export default Questionnaire;



// WEBPACK FOOTER //
// ./src/pages/personal/Questionnaire.tsx